export enum LocationCardStatus {
  SUCCESS,
  PENDING,
  WARNING,
  BULK_DEFAULT,
}
